export enum Paths {
    Owner = 'owner',
    Publisher = 'publisher'
}

export enum Roles {
    Admin = 'Admin',
    User = 'User',
    ReadOnlyUser = 'ReadOnlyUser'
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/enums.ts